import Table from "components/Table2";
import DateComp from "components/Table2/CellComps/Date";
import Price from "components/Table2/CellComps/Price";
import Text from "components/Table2/CellComps/Text";
import { useFormikContext } from "formik";

export default function InstallmentsList() {
  const data = useFormikContext<InstallmentData>();

  return (
    <div>
      <div className="mb-10 text-lg text-dark-3 font-IRANSansMedium">دفترچه اقساط</div>
      <Table
        headers={[
          { label: "عنوان" },
          { label: "مبلغ", style: { width: 200 } },
          { label: "تاریخ سررسید", style: { width: 200 } },
        ]}
        cols={[
          { key: "title", Comp: Text },
          {
            key: "price",
            Comp: Price,
            options: {
              editable: true,
              inputProps: { containerStyle: { width: 200 }, currency: data.values.currency?.en_title },
            },
          },
          {
            key: "date",
            Comp: DateComp,
            options: { editable: true, inputProps: { containerStyle: { width: 200 } } },
          },
        ]}
        rows={data.values.installmentRows}
        withoutMenu
        headerColor="#fff"
        bgColor="#fff"
        withBorder={true}
        tableBorder={false}
        onChange={(item: InstallmentRow) => {
          if (item.id === undefined) return;
          const newInstallments = [...(data.values.installmentRows || [])];
          newInstallments[item.id] = item;
          data.setFieldValue("installmentRows", newInstallments);
        }}
      />
      {!data.values.installmentRows?.length && (
        <div className="flex flex-col w-full gap-4 mt-4">
          {Array.from(Array(3).keys()).map((x) => (
            <div key={x} className="w-full h-16 rounded-md bg-slate-100" />
          ))}
        </div>
      )}
    </div>
  );
}
